import  useContext from "react";
import FlexList from "./FlexList";
import ModalExtra from "./ModalExtra";
import Button from "./common/Button";

function OverviewIcons(props) {

  return (
    <div className="md:tw-my-8 md:tw-flex md:tw-rounded-xl md:tw-bg-gray-light md:tw-p-5">
        <div className="md:tw-rounded-xl md:tw-bg-white md:tw-flex-0">
            <div className="tw-font-condensed tw-font-black tw-text-xl lg:tw-text-2xl tw-uppercase tw-italic tw-leading-3 tw-p-5 tw-pt-8">
            {props.headline}
            </div>
            {props.outsideModal}
            {props.extraTimesTitle}
            {props.extraTimesTable}
            {props.insideModal && (
            <>
                <div className="tw-p-5 tw-pb-12">
                <Button
                    size="medium"
                    color="black"
                    type="outline"
                    title={props.buttonTitle}
                    onClick={() => {
                        props.setHoursModalOpen(true);
                    }}
                    className="tw-mt-8 tw-w-full"
                />
                </div>
                <ModalExtra
                isOpen={props.hoursModalOpen}
                closeModal={props.closeHoursModal}
                title={props.modalTitle}
                subtitle={props.modalSubtitle}
                innerClassName="tw-p-5 tw-text-center"
                >
                {props.insideModal}
                </ModalExtra>
            </>
            )}
        </div>
        <div className="tw-p-5 tw-pb-12 tw-bg-gray-light md:tw-flex-1">
            <div className="tw-font-condensed tw-font-black tw-text-xl tw-pt-3 lg:tw-text-2xl tw-uppercase tw-italic tw-leading-5 md:tw-ml-5">
            {props.expect_in_club}
            </div>
            <FlexList
            className="tw-mt-3 tw-pt-5 tw-text-teal"
            items={props.features}
            lang={props.lang}
            />
        </div>
    </div>
  );
}

export default OverviewIcons;
